import { Link } from 'react-router';
import type { Robot } from '../api/types';
import { useT } from '../i18n';
import { updateChip } from '../lib/updates';

/** §29 robot page header: "App 0.2.4" / "Downloading 62%" / "Waiting for a tap on the robot"…; opens Updates. */
export function UpdateChip({ robot }: { robot: Robot }) {
  const t = useT();
  const c = updateChip(robot);
  if (!c) return null;
  return (
    <Link to="/updates" className={`upd-chip hide-mobile${c.tone === 'plain' ? '' : ` ${c.tone}`}`}>
      {t(c.key, c.vars)}
      {c.extra && <span style={{ color: '#7dbdf0' }}>· {t(c.extra.key, c.extra.vars)}</span>}
    </Link>
  );
}
